package com.cybersoftsolution.cybersoftsolutionweb.components.collapse

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.cybersoftsolution.cybersoftsolutionweb.components.buttons.MyButton
import com.cybersoftsolution.cybersoftsolutionweb.models.MyElement
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.TransitionProperty
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.attrsModifier
import com.varabyte.kobweb.compose.ui.modifiers.classNames
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexWrap
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.toAttrs
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Div


@Composable

inline fun <reified T: MyElement> CollapseContainer(
    useInnerToggleButtons: Boolean = true,
    id: String,
    modifier: Modifier = Modifier,
    elements: List<T>,
    crossinline content: @Composable (T) -> Unit
){

    var activeId by remember { mutableStateOf("") }



    Column(
        horizontalAlignment = Alignment.CenterHorizontally,
        verticalArrangement = Arrangement.Center,
        modifier = modifier
            .classNames(id)
            .transition(Transition.of(property = TransitionProperty.All, duration = 300.ms))
            .fillMaxWidth(),

        ){

        if (useInnerToggleButtons) {
            Div(
                attrs = Modifier
                    .display(DisplayStyle.Flex)
                    .flexWrap(FlexWrap.Wrap) // Permite que los elementos se envuelvan a la siguiente línea
                    .gap(16.px) // Espacio entre los botones
                    .toAttrs()
            ) {
                elements.forEach { element ->
                    MyButton(
                        modifier = Modifier
                            .height(38.px)
                            .attrsModifier {
//                            attr("type", "button")  ///Necessary if use any other component as toggle object
                                attr("data-bs-toggle", "collapse")
                                attr("data-bs-target", "#${element.id}")
                                attr("aria-expanded", "false")
                                attr("aria-controls", element.id?:"")
                            },
                        borderRadius = 35.px,
                        id = "${element.id}Button",
                        text = element.text,
                        fontSize = 14,
                        isActive = activeId == element.id,
                        onClick = {
                            if (activeId == element.id) {
                                activeId = ""
                            } else {
                                activeId = element.id?:""
                            }
                        }
                    )

                }


            }

        }

        elements.forEach { element ->
            Div(
                attrs = Modifier
                    .margin(top = 14.px)
                    .id(element.id?:"")
                    .classNames("collapse")
                    .toAttrs {
                        attr("data-bs-parent", ".${id}")
                    }
            ) {

                content(element)

            }
        }

    }






}




//@Composable
//fun CollapseContainer(
//    id: String,
//    modifier: Modifier = Modifier,
//    collapseElements: List<CollapseElement>,
//    content: @Composable (CollapseElement) -> Unit
//){
//
//    var activeId by remember { mutableStateOf("") }
//
//
//
//    Column(
//        horizontalAlignment = Alignment.CenterHorizontally,
//        verticalArrangement = Arrangement.Center,
//        modifier = modifier
//            .classNames(id)
//            .transition(Transition.of(property = TransitionProperty.All, duration = 300.ms))
//            .fillMaxWidth(),
//
//    ){
//
//
//        Div(
//            attrs = Modifier
//                .display(DisplayStyle.Flex)
//                .flexWrap(FlexWrap.Wrap) // Permite que los elementos se envuelvan a la siguiente línea
//                .gap(16.px) // Espacio entre los botones
//                .toAttrs()
//        ) {
//            collapseElements.forEach { element ->
//                MyButton(
//                    modifier = Modifier
//                        .height(38.px)
//                        .attrsModifier {
////                            attr("type", "button")  ///Necessary if use any other component as toggle object
//                            attr("data-bs-toggle", "collapse")
//                            attr("data-bs-target", "#${element.id}")
//                            attr("aria-expanded", "false")
//                            attr("aria-controls", element.id)
//                        },
//                    borderRadius = 35.px,
//                    id = "${element.id}Button",
//                    text = element.buttonText,
//                    fontSize = 14,
//                    isActive = activeId == element.id,
//                    onClick = {
//                        if (activeId == element.id) {
//                            activeId = ""
//                        } else {
//                            activeId = element.id
//                        }
//                    }
//                )
//
//            }
//
//
//        }
//
//        collapseElements.forEach { element ->
//            Div(
//                attrs = Modifier
//                    .margin(top = 14.px)
//                    .id(element.id)
//                    .classNames("collapse")
//                    .toAttrs {
//                         attr("data-bs-parent", ".${id}")
//                    }
//            ) {
//                Column {
//                    SpanText(
//                        modifier = Modifier
//                            .margin(bottom = 10.px)
//                            .fontSize(18.px)
//                            .fontWeight(FontWeight.Bold),
//                        text = element.title
//                    )
//                    SpanText(
//                        text = element.text
//                    )
//                    content(element)
//                }
//
//            }
//        }
//
//    }
//
//
//
//
//
//
//}
//
